import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { AttivazioneClienteComponent } from './attivazione-cliente';

let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

  $stateProvider
    .state('home.attivazione-cliente', {
      url: '/attivazione-cliente',
      ncyBreadcrumb: {
        label: 'Attivazione Cliente',
        parent: 'home.admin'
      },
      data: {
        authorisationLevel: 2,
        pageTitle: 'Attivazione Cliente'
      },
      'views': {
        'homeContent': {
          template: '<attivazione-cliente flex="100"></attivazione-cliente>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const AttivazioneClienteModule: string = ng
  .module('attivazione-cliente', [
    'ui.bootstrap',
    uiRouter,
  ])
  .component('attivazioneCliente', AttivazioneClienteComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/attivazione-cliente/attivazione-cliente.module.ts